import { useCallback } from "react";

interface UseFullscreenProps {
  map?: google.maps.Map;
}

export const useFullscreen = ({ map }: UseFullscreenProps = {}) => {
  const toggleFullscreen = useCallback((element: HTMLElement) => {
    if (!document.fullscreenElement) {
      element.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch((err) => {
        console.error(`Error attempting to exit fullscreen: ${err.message}`);
      });
    }
  }, []);

  return {
    toggleFullscreen,
  };
};
